"use client";
import E from "./index.es17.js";
import "./index.es9.js";
import n, { useState as h, useEffect as k, useId as b } from "react";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import v from "./index.es73.js";
import f from "./index.es59.js";
import { bufdirHashNavigateEvent as u } from "./index.es7.js";
const C = f.div`
  .bl-accordion:not(.bl-accordion--is-closed) .bl-accordion__content {
    overflow: visible;
  }
`, g = f.div`
  text-align: right;
`, y = ({
  content: m,
  htmlId: o,
  title: t,
  tooltips: a,
  keyContext: r,
  isOpen: c,
  onChange: s
}) => {
  const e = b(), l = () => {
    s(!c);
  };
  return /* @__PURE__ */ n.createElement(
    v,
    {
      contentId: e,
      onClick: l,
      isOpen: c,
      header: /* @__PURE__ */ n.createElement("span", { ...o ? { id: o } : {} }, t)
    },
    /* @__PURE__ */ n.createElement(
      E,
      {
        keyContext: `${r}-content`,
        className: "bl-p-b-3",
        content: m,
        tooltips: a
      }
    )
  );
}, D = ({
  keyContext: m,
  accordions: o
}) => {
  const [t, a] = h(
    /* @__PURE__ */ new Set()
  );
  k(() => {
    const e = (l) => {
      const { detail: p } = l, i = o.find(
        (d) => d.htmlId === p
      );
      if (i && !t.has(i.id)) {
        t.add(i.id);
        const d = new Set(t);
        d.add(i.id), a(d);
      }
    };
    return document.addEventListener(
      u,
      e
    ), () => {
      document.removeEventListener(
        u,
        e
      );
    };
  }, [t]);
  const r = t.size >= o.length, c = r ? "Lukk Alle" : "Åpne Alle", s = (e) => {
    e.preventDefault(), a(r ? /* @__PURE__ */ new Set() : new Set(o.map((l) => l.id)));
  };
  return o && Array.isArray(o) ? /* @__PURE__ */ n.createElement(C, null, o.length > 1 && /* @__PURE__ */ n.createElement(g, null, /* @__PURE__ */ n.createElement("a", { href: "#", onClick: s, className: "bl-link bl-m-y-2" }, c)), /* @__PURE__ */ n.createElement("ul", null, /* @__PURE__ */ n.createElement("li", null, o.map((e) => {
    const l = `${m}-accordion-${e.id}`, p = (i) => {
      i ? t.add(e.id) : t.delete(e.id), a(new Set(t));
    };
    return /* @__PURE__ */ n.createElement(
      y,
      {
        ...e,
        keyContext: l,
        key: l,
        isOpen: t.has(e.id),
        onChange: p
      }
    );
  })))) : /* @__PURE__ */ n.createElement(n.Fragment, null);
};
export {
  D as default
};
//# sourceMappingURL=index.es31.js.map
